/* Light Experience | رحلة الضوء — scroll progress → light stages (sections/elw-light-experience.liquid).
   One rAF-throttled scroll handler per section, active only while the section is near the viewport.
   Reduced motion: the lit room shows statically with an on/off switch. */
(function () {
  function sm(x) { x = x < 0 ? 0 : x > 1 ? 1 : x; return x * x * (3 - 2 * x); }

  function init(root) {
    if (root.__lx) return; root.__lx = true;
    var stage = root.querySelector('.lx-stage');
    var steps = [].slice.call(root.querySelectorAll('.lx-step'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var photo = root.classList.contains('lx--photo');

    function set(p) {
      var s1 = sm((p - 0.05) / 0.2), s2 = sm((p - 0.28) / 0.2), s3 = sm((p - 0.5) / 0.2), s4 = sm((p - 0.7) / 0.2);
      var st = root.style;
      st.setProperty('--p', p.toFixed(4));
      st.setProperty('--s1', s1.toFixed(3)); st.setProperty('--s2', s2.toFixed(3));
      st.setProperty('--s3', s3.toFixed(3)); st.setProperty('--s4', s4.toFixed(3));
      st.setProperty('--dark', (0.9 - 0.2 * s1 - 0.12 * s2 - 0.08 * s3 - 0.18 * s4).toFixed(3));
      var on = [s1, s2, s3, s4], last = -1;
      steps.forEach(function (e, i) { var lit = on[i] > 0.5; e.classList.toggle('is-on', lit); if (lit) last = i; });
      steps.forEach(function (e, i) { if (i === last) e.setAttribute('aria-current', 'step'); else e.removeAttribute('aria-current'); });
      var lit = photo ? p > 0.9 : s4 > 0.6;
      if (lit !== root.classList.contains('is-lit')) {
        root.classList.toggle('is-lit', lit);
        frameHs();
        if (!lit) closePop();
      }
    }

    /* hotspots: focusable only when lit and inside the cropped frame (portrait screens crop the scene) */
    function frameHs() {
      var sr = stage.getBoundingClientRect(), lit = root.classList.contains('is-lit');
      root.querySelectorAll('.lx-hs').forEach(function (h) {
        var r = h.getBoundingClientRect(), cx = r.left + r.width / 2;
        var inside = cx > sr.left + 12 && cx < sr.right - 12;
        h.classList.toggle('lx-hs--off', !inside);
        h.setAttribute('tabindex', lit && inside ? '0' : '-1');
      });
    }
    window.addEventListener('resize', function () { frameHs(); });

    /* product popovers */
    var openHs = null;
    function closePop() {
      if (!openHs) return;
      var pop = document.getElementById(openHs.getAttribute('data-pop'));
      if (pop) pop.hidden = true;
      openHs.setAttribute('aria-expanded', 'false');
      openHs = null;
    }
    function openPop(hs) {
      if (openHs === hs) { closePop(); return; }
      closePop();
      var pop = document.getElementById(hs.getAttribute('data-pop'));
      if (!pop) return;
      pop.hidden = false;
      var sr = stage.getBoundingClientRect(), hr = hs.getBoundingClientRect(), pr = pop.getBoundingClientRect();
      var x = hr.left + hr.width / 2 - sr.left - pr.width / 2;
      x = Math.max(16, Math.min(x, sr.width - pr.width - 16));
      var y = hr.top - sr.top - pr.height - 14;
      if (y < 16) y = hr.bottom - sr.top + 14;
      pop.style.left = x + 'px'; pop.style.top = y + 'px';
      hs.setAttribute('aria-expanded', 'true');
      openHs = hs;
      var link = pop.querySelector('a'); if (link) link.focus({ preventScroll: true });
    }
    root.addEventListener('click', function (e) {
      var hs = e.target.closest('.lx-hs');
      if (hs) { openPop(hs); return; }
      if (e.target.closest('.lx-pop__x')) { var h = openHs; closePop(); if (h) h.focus({ preventScroll: true }); return; }
      if (!e.target.closest('.lx-pop')) closePop();
    });
    root.addEventListener('keydown', function (e) {
      var hs = e.target.closest && e.target.closest('.lx-hs');
      if (hs && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); openPop(hs); }
      if (e.key === 'Escape' && openHs) { var h = openHs; closePop(); h.focus({ preventScroll: true }); }
    });

    if (reduce) {
      root.classList.add('lx--static');
      var sw = root.querySelector('.lx-switch'), isOn = true;
      set(1);
      if (sw) sw.addEventListener('click', function () {
        isOn = !isOn; set(isOn ? 1 : 0);
        sw.setAttribute('aria-pressed', isOn ? 'true' : 'false');
        sw.textContent = isOn ? sw.getAttribute('data-on') : sw.getAttribute('data-off');
      });
      return;
    }

    root.classList.add('lx--scroll');
    var header = document.querySelector('.elw-header-section') || document.querySelector('header.shopify-section');
    var lxTop = 0;
    function topOffset() {
      var stick = header && getComputedStyle(header).position === 'sticky';
      lxTop = stick ? Math.round(header.getBoundingClientRect().height) : 0;
      root.style.setProperty('--lx-top', lxTop + 'px');
    }
    var last = -1, ticking = false, near = false;
    function update() {
      ticking = false;
      var r = root.getBoundingClientRect();
      var total = root.offsetHeight - stage.offsetHeight;
      var p = total > 0 ? (lxTop - r.top) / total : 1;
      p = Math.max(0, Math.min(1, p / 0.9));
      if (Math.abs(p - last) > 0.0008) { last = p; set(p); }
    }
    function onScroll() { if (near && !ticking) { ticking = true; requestAnimationFrame(update); } }
    new IntersectionObserver(function (es) { near = es[0].isIntersecting; if (near) onScroll(); }, { rootMargin: '200px 0px' }).observe(root);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { topOffset(); last = -1; near = true; onScroll(); });
    topOffset();
    set(0);
    near = true; update();
  }

  function boot() { document.querySelectorAll('.lx').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
